<template>
  <div class="evaluationStaffSignUp common_content">
    <div class="con">
      <div v-if="tbodyShow">
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order">
              <span
                >订单时间：{{
                  tbody.creationTime | dateformat("YYYY-MM-DD HH:mm:ss")
                }}</span
              >
              <span>订单号：{{ tbody.order_sn }}</span>
            </div>
            <div class="order_detail">
              <div class="detail_con">
                <ul style="width: 76%">
                  <li>
                    <label>培训名称：</label>
                    <span>{{ tbody.trainClassName }}</span>
                  </li>
                  <li>
                    <label>培训类型：</label>
                    <span>{{ tbody.trainType }}</span>
                  </li>
                  <li>
                    <label>培训等级：</label>
                    <span>{{ tbody.grade | grade }}</span>
                  </li>
                  <li>
                    <label>报名类型：</label>
                    <span>{{ tbody.feeType | feeType }}</span>
                  </li>
                  <li>
                    <label>培训时间：</label>
                    <span>
                      {{
                        tbody.opening_class_start_time
                          | dateformat("YYYY-MM-DD HH:mm:ss")
                      }}至
                      {{
                        tbody.opening_class_end_time
                          | dateformat("YYYY-MM-DD HH:mm:ss")
                      }}
                    </span>
                  </li>
                  <li>
                    <label>培训地址：</label>
                    <span
                      >{{
                        tbody.provinceName == tbody.cityName
                          ? tbody.provinceName
                          : tbody.provinceName + tbody.cityName
                      }}{{ tbody.districtName }}{{ tbody.detail_addr }}</span
                    >
                  </li>
                  <li v-if="tbody.grade != 3">
                    <label>培训资质：</label>
                    <p>{{ tbody.aptitude }}</p>
                  </li>
                </ul>
              </div>
              <div class="money">
                <h4>金额:¥{{ tbody.order_price }}</h4>
              </div>
              <div class="operate">
                <h4>实付:¥{{ tbody.order_price }}</h4>
              </div>
            </div>
          </li>
        </ul>
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order">
              <span style="display: block; float: left">培训内容</span>
            </div>
            <div class="order_detail">
              <el-table
                :data="tbody.contents"
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column label="序号" width="70px">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <!--                <el-table-column prop="teacher" label="教师" align="center"></el-table-column>
                                <el-table-column prop="title" label="职称" align="center"></el-table-column>-->
                <el-table-column
                  prop="content"
                  label="培训内容"
                  align="center"
                ></el-table-column>
                <!--                <el-table-column prop="time" label="学时数" align="center"></el-table-column>-->
                <el-table-column
                  prop="assessment_method"
                  label="考核方式"
                  align="center"
                ></el-table-column>
              </el-table>
            </div>
          </li>
        </ul>
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order">
              <span style="display: block; float: left">培训通知</span>
            </div>
            <div>
              <p
                v-html="notice_content"
                style="text-indent: 25px; padding: 10px 0px"
              ></p>
            </div>
          </li>
        </ul>
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order">
              <span>发票信息：</span>
            </div>
            <div style="padding: 15px 10px; font-size: 15px">
              <span style="padding: 0px 10px; color: #ea0000">{{
                radio == "1" ? "个人" : "企业"
              }}</span>
              <!-- <span style="padding:0px 10px;" v-if="radio=='2'">购方名称：{{formInvoice.custname}}</span>
              <span style="padding:0px 10px;" v-if="radio=='2'">购方税号：{{formInvoice.custTaxNo}}</span>-->
              <span class="upData" @click="InvoiceVisible = true">修改</span>
            </div>
            <div
              class="invoiceDetail"
              style="padding: 0 15px; font-size: 15px; line-height: 26px"
            >
              <ul>
                <li v-for="(item, index) in comonInvoice" :key="index">
                  <span>{{ item.title }}</span>
                  <span>{{ item.value }}</span>
                </li>
              </ul>
              <ul v-if="radio == '2'">
                <li>
                  <span>单位名称：</span>
                  <span>{{ formInvoice.custname }}</span>
                </li>
                <li>
                  <span>纳税人识别号：</span>
                  <span>{{ formInvoice.custTaxNo }}</span>
                </li>
                <li>
                  <span>注册地址：</span>
                  <span>{{ formInvoice.custAddr }}</span>
                </li>
                <li>
                  <span>注册电话：</span>
                  <span>{{ formInvoice.custPhone }}</span>
                </li>
                <li>
                  <span>开户银行：</span>
                  <span>{{ formInvoice.custBank }}</span>
                </li>
                <li>
                  <span>银行账号：</span>
                  <span>{{ formInvoice.custAccount }}</span>
                </li>
                <li>
                  <span>备注：</span>
                  <span>{{ formInvoice.invoMemo }}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <no-data v-else />
      <makeOutInvoice
        :dialogVisible="InvoiceVisible"
        ref="invoice"
        @default="defaultData"
        @cancel="cancelData"
      />
      <el-card class="box-card signUp_card">
        <span>合计：</span>
        <span style="color: #ea3553">￥{{ tbody.order_price }}</span>
        <el-button
          type="danger"
          style="width: 100px; height: 40px"
          @click="Settlement"
          :loading="loading"
          >待审核
        </el-button>
      </el-card>
    </div>
    <el-dialog
      title="二维码支付"
      :visible.sync="paydialog"
      :width="screenWidth > 768 ? '40%' : '90%'"
      center
      :close-on-click-modal="false"
      @close="goToOrder"
    >
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img" />
        <div>仅支持微信扫码支付</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import noData from "@/views/admin/components/noData.vue";
import makeOutInvoice from "@/views/admin/components/makeOutInvoice.vue";
import {
  GetUserInvoiceInfo,
  GetDicData,
  GDCloudPayV2,
  GetPaymentStatus,
} from "@/api/admin/common.js";
import { TrainClassData } from "@/api/admin/appraiser.js";
import { mapGetters } from "vuex";

let that = this;
export default {
  components: {
    noData,
    makeOutInvoice,
  },
  computed: {
    ...mapGetters(["screenWidth"]),
  },
  data() {
    return {
      payview: false,
      tbody: {},
      notice_content: "",
      tbodyShow: false,
      InvoiceVisible: false,
      formData: {},
      paydialog: false,
      radio: "1",
      newId: {},
      time: null,
      appraiser_grade: [],
      imgPath: window.apiObj.apiUrl,
      formInvoice: {},
      comonInvoice: [
        { title: "发票类型：", value: "电子普通发票" },
        { title: "发票内容：", value: "商品明细" },
      ],
      loading: false,
      feeTypeOptions: [
        {
          label: "培训",
          value: 1,
        },
        {
          label: "考核",
          value: 2,
        },
        {
          label: "培训+考核",
          value: 3,
        },
      ],
    };
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
  created() {
    this.path();
    this.getList();
    this.defaultData();
    // this.intervalPay();
    // this.time = setInterval(() => {
    //   this.intervalPay();
    // }, 10000);
  },
  beforeCreate: function () {
    that = this;
  },
  mounted() {
    this.searchBus.$on("cancel", (msg) => {
      this.InvoiceVisible = msg;
    });
  },
  methods: {
    intervalPay() {
      if (this.payview) {
        GetPaymentStatus({ order_sn: this.tbody.order_sn }).then((data) => {
          if (data.data.result.orderStatus == 3) {
            this.$message({
              message: "支付完成",
              type: "success",
            });
            this.paydialog = false;
            this.payview = false;
            this.goToOrder();
          }
        });
      }
    },
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { path: "/evaluationStaffTraining", title: "考评员" },
        {
          path: "/evaluationStaffTraining",
          title: "考评员培训",
        },
        {
          title: "考评员培训详情",
          path:
            "/evaluationStaffTraining/evaluationStaffTrainingDetail?id=" +
            this.$route.query.id,
        },
        {
          title: "确认订单",
          path: this.$route.fullPath,
        },
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    defaultData() {
      GetUserInvoiceInfo({}).then((data) => {
        var list = data.data.result;
        if (list.invoiceInfo) {
          if (list.invoiceInfo.custtype == "01") {
            this.radio = "2";
            this.formInvoice = list.invoiceInfo;
          } else {
            this.radio = "1";
          }
        }
      });
      GetDicData({ classCode: "appraiser_grade" }).then((data) => {
        if (data.data.result) {
          this.appraiser_grade = data.data.result;
        }
      });
    },
    getList() {
      this.newId = this.$route.query;
      TrainClassData({ id: this.newId.id }).then((data) => {
        const list = data.data.result;
        if (list) {
          if (list.items.length > 0) {
            var temII = list.items.length - 1;

            this.tbodyShow = true;
            this.tbody = list.items[temII];
            if (list.items[temII].notice_content) {
              this.notice_content = list.items[temII].notice_content.replace(
                new RegExp("/wwwroot", "gm"),
                this.imgPath
              );
            }
          } else {
            this.tbodyShow = false;
          }
        }
      });
    },
    cancel() {},
    Settlement() {
      this.$message({
        message: '报名信息已提交，审核中',
        type: "warning",
      });
      //this.tbody = this.$route.query.tbody;
      /*GDCloudPayV2({ order_sn: this.tbody.order_sn }).then((data) => {
        if (data.data.result.isSuccess) {
          this.paydialog = true;
          this.payview = true;
          //this.formData.img = "http://218.58.55.130:8765"+data.data.result.payCode;
          this.formData.img = this.imgPath + data.data.result.payCode;
        } else {
          this.$message({
            message: data.data.result.errorMsg,
            type: "error",
          });
        }
        // this.payview=true;
        // this.paydialog = true;
      });*/
      //         GetPaymentStatus({ order_sn: this.tbody.order_sn }).then(data => {
      //             if(data.data.result.orderStatus==3){

      //               this.paydialog = false;
      //             }

      //       });
      // //vue实现每隔几秒请求一次接口（轮询）
      //       window.setInterval(() => {
      //         setTimeout(this.GetPaymentStatus, 0)
      //       }, 30000)

      //this.formData.img = "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1588778722186&di=c54f602d1747bc6ac026b0f49c743eb0&imgtype=0&src=http%3A%2F%2Fa2.att.hudong.com%2F36%2F48%2F19300001357258133412489354717.jpg";
    },
    cancelData() {
      this.InvoiceVisible = false;
    },
    goToOrder() {
      this.$router.push({ path: "/personal/trainingRecord" });
    },
  },
  filters: {
    grade: (data) => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    },
    feeType: (data) => {
      let feeType = that.feeTypeOptions.find((it) => it.value == data);
      if (feeType) {
        return feeType.label;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.evaluationStaffSignUp {
  background: #fff;

  .con {
    border: 1px solid #dcdfe6;
    padding: 5px;
    margin-top: 5px;

    .thead {
      background: #f5f6f6;
      overflow: hidden;

      li {
        float: left;
        padding: 6px;
        box-sizing: border-box;
        text-align: center;
      }

      li:first-child {
        width: 50%;
      }

      li:nth-child(2) {
        width: 20%;
      }

      li:nth-child(3) {
        width: 30%;
      }
    }

    .tbody {
      .tbody_con {
        border-bottom: 1px solid #dcdfe6;

        .order {
          padding: 6px 18px;
          background: #f5f6f6;
          overflow: hidden;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
        }

        .invoiceDetail {
          ul {
            li {
              line-height: 30px;

              span:first-child {
                display: inline-block;
                width: 105px;
                text-align: right;
                margin-right: 10px;
              }
            }
          }
        }

        .order_detail {
          padding: 15px 10px;
          display: flex;
          align-items: inherit;
          justify-content: space-around;

          .detail_con {
            width: 60%;

            ul {
              li {
                line-height: 25px;
                font-size: 15px;
                display: flex;

                label {
                  display: block;
                  width: 100px;
                  text-align: center;
                }

                span {
                  display: block;
                  width: 72%;
                }
              }
            }
          }

          .money {
            width: 20%;
            border-left: 1px solid rgb(196, 196, 196);
            border-right: 1px solid rgb(196, 196, 196);
            display: flex;
            align-items: center;
            justify-content: center;

            h4 {
              font-weight: normal;
            }
          }

          .operate {
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .upData {
          color: #409eff;
          cursor: pointer;
          margin-left: 30px;
        }

        .upData:hover {
          opacity: 0.5;
        }

        @media screen and (max-width: 500px) {
          .order_detail {
            flex-direction: column;

            .detail_con {
              width: 100% !important;
            }

            .money {
              width: 100% !important;

              h4 {
                text-align: center;
                padding: 10px;
              }
            }

            .operate {
              width: 100% !important;

              h4 {
                text-align: center;
                padding: 10px;
              }
            }
          }

          .order {
            flex-direction: column;
          }
        }
      }
    }
  }

  .signUp_card {
    margin-top: 10px;
    text-align: right;

    span {
      display: inline-block;
      margin-right: 10px;
      font-size: 16px;
    }

    span + span {
      font-size: 18px;
    }
  }
}

.paystyle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  color: #ea0000;
}
</style>
